import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Draggable from 'react-draggable';

const MapKey = () => {

  const [isExpanded, toggleIsExpanded] = useState(false),
        mainviewProps = useSelector(store => store.mainview);
  
  if (!(mainviewProps.showSightingLayer
    || mainviewProps.showFederalLayer
    || mainviewProps.showLGALayer
    || mainviewProps.showStateLayer
    || mainviewProps.showPreClearingHabitat
    || mainviewProps.showNVISHabitat
    || mainviewProps.showKHAHabitat
    || mainviewProps.showPropertyLayer)) return false;

  return (
    <Draggable bounds="parent" handle=".map__key-move">
      <div className={ `map__key ${ isExpanded ? 'map__key--expanded' : '' }` }>
        <span title="Click &amp; drag here to move the map legend" className="map__key-move">
          <i className="fas fa-arrows-alt"></i>
        </span>

        <span onClick={ () => toggleIsExpanded(!isExpanded) } title={ isExpanded ? 'Click to reduce map legend' : 'Click to expand map legend' } className="map__key-toggler">
          {
            isExpanded &&
            <i className="fas fa-compress-alt"></i>
          }
          {
            !isExpanded &&
            <i className="fas fa-expand-alt"></i>
          }
        </span>
        
        {
          !isExpanded &&
          <span className="map__key-item map__key-item--title">Map Legend</span>
        }

        {
          isExpanded &&
          <div className="map__key-content">

            <div className="map__key-content-half">
              {
                mainviewProps.showSightingLayer &&
                <>
                  <span className="map__key-item"><img src={ `${ process.env.REACT_APP_ROOT_TILES }/media/KHH.png` } style={{ height: 'auto', maxWidth: 30, margin: '0 10px 0 -9px' }} alt="Healthy koala icon" /> Healthy Koala</span>
                  <span className="map__key-item"><img src={ `${ process.env.REACT_APP_ROOT_TILES }/media/KHS.png` } style={{ height: 'auto', maxWidth: 30, margin: '0 10px 0 -9px' }} alt="Sick koala icon" /> Sick/Injured Koala</span>
                  <span className="map__key-item"><img src={ `${ process.env.REACT_APP_ROOT_TILES }/media/KHD.png` } style={{ height: 'auto', maxWidth: 30, margin: '0 10px 0 -9px' }} alt="Deceased koala icon" /> Deceased Koala</span>
                  <span className="map__key-item"><img src={ `${ process.env.REACT_APP_ROOT_TILES }/media/KHU.png` } style={{ height: 'auto', maxWidth: 30, margin: '0 10px 0 -9px' }} alt="Unknown koala icon" /> Unknown Koala</span>
                </>
              }

              {
                mainviewProps.showPropertyLayer &&
                <span className="map__key-item"><span className="badge badge--property-orange badge--hollow">&nbsp;</span> Property Boundaries</span>
              }

              {
                mainviewProps.showFederalLayer &&
                <span className="map__key-item"><span className="badge badge--federal-blue badge--hollow">&nbsp;</span>Federal Electoral Boundaries</span>
              }

              {
                mainviewProps.showLGALayer &&
                <span className="map__key-item"><span className="badge badge--lga-purple badge--hollow">&nbsp;</span>Local Government Authorites</span>
              }

              {
                mainviewProps.showStateLayer &&
                <span className="map__key-item"><span className="badge badge--state-brown badge--hollow">&nbsp;</span>State Electoral Boundaries</span>
              }
            
              {
                mainviewProps.showNVISHabitat &&
                <span className="map__key-item"><span className="badge badge--nvis-green">&nbsp;</span>NVIS Habitat</span>
              }
            </div>
            
            {
              mainviewProps.showKHAHabitat &&
              <div className="map__key-content-half map__key-content-half--grow">
                <span className="map__key-item"><span className="badge badge--kha-red">&nbsp;</span>Primary Habitat</span>
                <span className="map__key-item"><span className="badge badge--kha-green-a">&nbsp;</span>Secondary Habitat (Class A)</span>
                <span className="map__key-item"><span className="badge badge--kha-green-b">&nbsp;</span>Secondary Habitat (Class B)</span>
                <span className="map__key-item"><span className="badge badge--kha-green-c">&nbsp;</span>Secondary Habitat (Class C)</span>
                <span className="map__key-item"><span className="badge badge--kha-malacite">&nbsp;</span>Mainly Cleared</span>
		<span className="map__key-item"><span className="badge badge--kha-rock">&nbsp;</span>Rock</span>
		<span className="map__key-item"><span className="badge badge--kha-sand">&nbsp;</span>Sand</span>
		<span className="map__key-item"><span className="badge badge--kha-water">&nbsp;</span>Water</span>
		<span className="map__key-item"><span className="badge badge--kha-purple">&nbsp;</span>Unknown Habitat Quality</span>
                <span className="map__key-item"><span className="badge badge--kha-yellow">&nbsp;</span>Other vegetation</span>
              </div>
            }

            {
              mainviewProps.showPreClearingHabitat &&
              <div className="map__key-content-half map__key-content-half--grow">
                <span className="map__key-item"><span className="badge badge--preclear-red">&nbsp;</span>Primary Habitat</span>
                <span className="map__key-item"><span className="badge badge--preclear-green-a">&nbsp;</span>Secondary Habitat (Class A)</span>
                <span className="map__key-item"><span className="badge badge--preclear-green-b">&nbsp;</span>Secondary Habitat (Class B)</span>
                <span className="map__key-item"><span className="badge badge--preclear-green-c">&nbsp;</span>Secondary Habitat (Class C)</span>
                <span className="map__key-item"><span className="badge badge--preclear-rock">&nbsp;</span>Rock</span>
                <span className="map__key-item"><span className="badge badge--preclear-sand">&nbsp;</span>Sand</span>
                <span className="map__key-item"><span className="badge badge--preclear-water">&nbsp;</span>Water</span>
                <span className="map__key-item"><span className="badge badge--preclear-purple">&nbsp;</span>Unknown Habitat Quality</span>
                <span className="map__key-item"><span className="badge badge--preclear-yellow">&nbsp;</span>Other vegetation</span>
              </div>
            }

          </div>
        }

      </div>
    </Draggable>
  );
  
}

export default MapKey;
